/**
 * MD5 (RFC 1321) de texto UTF-8, em hexadecimal minúsculo.
 *
 * Existe só para as chamadas legadas que autenticam com md5 de um código (ex.:
 * log de notificação, pass=md5(CNPJ) — o mesmo que o desktop manda). Não usar
 * para nada que precise de segurança.
 */
export function md5(texto: string): string {
  const bytes = new TextEncoder().encode(texto ?? '');
  const tamanhoBits = bytes.length * 8;

  // mensagem + 0x80 + zeros até 56 mod 64 + tamanho (64 bits little-endian)
  const totalBytes = (((bytes.length + 8) >> 6) + 1) * 64;
  const buffer = new Uint8Array(totalBytes);
  buffer.set(bytes);
  buffer[bytes.length] = 0x80;
  const visao = new DataView(buffer.buffer);
  visao.setUint32(totalBytes - 8, tamanhoBits >>> 0, true);
  visao.setUint32(totalBytes - 4, Math.floor(tamanhoBits / 0x100000000), true);

  let a0 = 0x67452301;
  let b0 = 0xefcdab89;
  let c0 = 0x98badcfe;
  let d0 = 0x10325476;

  const m = new Uint32Array(16);
  for (let bloco = 0; bloco < totalBytes; bloco += 64) {
    for (let i = 0; i < 16; i++) {
      m[i] = visao.getUint32(bloco + i * 4, true);
    }
    let a = a0, b = b0, c = c0, d = d0;
    for (let i = 0; i < 64; i++) {
      let f: number;
      let g: number;
      if (i < 16) {
        f = (b & c) | (~b & d);
        g = i;
      } else if (i < 32) {
        f = (d & b) | (~d & c);
        g = (5 * i + 1) % 16;
      } else if (i < 48) {
        f = b ^ c ^ d;
        g = (3 * i + 5) % 16;
      } else {
        f = c ^ (b | ~d);
        g = (7 * i) % 16;
      }
      const soma = (a + f + K[i] + m[g]) | 0;
      a = d;
      d = c;
      c = b;
      b = (b + ((soma << S[i]) | (soma >>> (32 - S[i])))) | 0;
    }
    a0 = (a0 + a) | 0;
    b0 = (b0 + b) | 0;
    c0 = (c0 + c) | 0;
    d0 = (d0 + d) | 0;
  }

  return [a0, b0, c0, d0].map(hexLittleEndian).join('');
}

function hexLittleEndian(n: number): string {
  let s = '';
  for (let i = 0; i < 4; i++) {
    s += ((n >>> (i * 8)) & 0xff).toString(16).padStart(2, '0');
  }
  return s;
}

const S = [
  7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22,
  5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
  4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23,
  6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21,
];

const K = Array.from({ length: 64 }, (_, i) => Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000) | 0);
